import type { Locale } from '@atlassian/jira-common-constants/src/supported-locales.tsx';

export const DEFAULT_CURRENCY_CODE = 'USD';
export const DEFAULT_CURRENCY_DISPLAY = 'narrowSymbol';
export const FORMAT_STYLE_DECIMAL = 'DECIMAL';
export const FORMAT_STYLE_CURRENCY = 'CURRENCY';
export const FORMAT_STYLE_PERCENT = 'PERCENT';
export const FORMAT_STYLE_UNIT = 'UNIT';

export const FORMAT_UNIT_LITER = 'liter';
export const FORMAT_UNIT_METER = 'meter';
export const FORMAT_UNIT_KILOGRAM = 'kilogram';
export const FORMAT_UNIT_PERCENT = 'percent';

type LocaleOption = {
	/** BCP 47 language tag (e.g. ja-JP) that ensures currencies are in the official format for the locale. Defaults to 'en-US'. */
	locale?: Locale;
};

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
export type CurrencyDisplayOptions = Intl.NumberFormatOptions &
	LocaleOption & {
		/** ISO_4217 currency alpha codes. E.g. USD */
		currencyCode?: string;

		/**
		 * How to display the currency in currency formatting. Defaults to 'symbol'.
		 * - "symbol" to use a localized currency symbol such as €.
		 * - "narrowSymbol" to use a narrow format symbol ("$100" rather than "US$100"), this is the default value,
		 * - "code" to use the ISO currency code,
		 * - "name" to use a localized currency name such as "dollar",
		 */
		currencyDisplay?: 'symbol' | 'narrowSymbol' | 'code' | 'name';
	};

export type NumberFieldDisplayOptions = Intl.NumberFormatOptions & LocaleOption;

export type FormatStyle =
	| typeof FORMAT_STYLE_DECIMAL
	| typeof FORMAT_STYLE_CURRENCY
	| typeof FORMAT_STYLE_PERCENT
	| typeof FORMAT_STYLE_UNIT;

export type NumberFieldDisplayConfig = {
	formatStyle: string;
	formatUnit?: string | null;
	locale?: Locale;
};
